import { Button, Menu, MenuItem } from '@mui/material';
import React from 'react';
import { createStyleSheet } from 'utils/helpers';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { setViewMode } from 'slices/viewModeSlice';
import { useAppDispatch } from 'common/hook';
const ViewMode: React.FC = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const sendMessageToParent = (newMode: 'tablet' | 'mobile' | 'pc') => {
        window.parent.postMessage(
            { type: 'CHANGE_MODE', payload: { mode: newMode } },
            window.location.origin
        );
    };
    const dispatch = useAppDispatch();
    return (
        <>
            <Button
                id="basic-button"
                variant="contained"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                endIcon={
                    <ExpandMoreIcon
                        sx={{
                            width: [22, 22, 22, 28, 32],
                            height: [22, 22, 22, 28, 32],
                        }}
                    />
                }
                sx={styles.btnViewMode}
            >
                Chế độ xem
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                sx={{
                    '& .MuiPaper-root': {
                        borderRadius: '7px',
                        marginTop: '10px',
                        minWidth: ['5rem', '7rem', '10rem', '12rem', '14rem'],
                        padding: '8px 16px',
                    },
                }}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem
                    className="navigate-button"
                    sx={styles.viewModeItem}
                    onClick={() => {
                        dispatch(setViewMode('pc'));
                        sendMessageToParent('pc');
                        handleClose();
                    }}
                >
                    Website
                </MenuItem>
                <MenuItem
                    sx={styles.viewModeItem}
                    onClick={() => {
                        sendMessageToParent('tablet');
                        dispatch(setViewMode('tablet'));
                        handleClose();
                    }}
                >
                    Máy tính bảng
                </MenuItem>
                <MenuItem
                    sx={styles.viewModeItem}
                    onClick={() => {
                        sendMessageToParent('mobile');
                        dispatch(setViewMode('mobile'));
                        handleClose();
                    }}
                >
                    Điện thoại
                </MenuItem>
            </Menu>
        </>
    );
};
const styles = createStyleSheet({
    viewModeItem: {
        borderBottom: '1px solid #ccc',
        ':hover': {
            backgroundColor: 'none',
        },
        '&:last-child': { borderBottom: 'none' },
    },
    btnViewMode: {
        minWidth: ['5rem', '7rem', '10rem', '12rem', '13rem'],
        height: ['2.5rem', '2rem', '2rem', '3rem', '3rem'],
        textTransform: 'none',
        borderRadius: '40px',
        fontSize: ['0.6rem', '0.7rem', '0.7rem', '1rem', '1rem'],
        fontWeight: '700',
        padding: ['1rem', '1rem', '1rem', '1.5rem 3rem'],
    },
});

export default ViewMode;
